import { useMemo } from 'react';
import { Flex, Typography } from '@banhala/ui-kit';
import type { HeadlineSmallOneLineWithTextProps } from './types';
import { isNil, renderHTMLToText } from '../../../../utils';

export const HeadlineSmallOneLineWithText = ({
  header,
}: HeadlineSmallOneLineWithTextProps) => {
  const headerText = header?.item.text;
  const textElement = useMemo(() => {
    if (isNil(headerText)) return null;

    return renderHTMLToText(headerText);
  }, [headerText]);

  if (isNil(header)) return null;

  return (
    <Flex.Row
      padding={{ horizontal: 16, vertical: 16 }}
      justifyContent={'space-between'}
      alignItems={'center'}
      testID={header.item.title}
    >
      <Typography type="h5" color="content_primary">
        {header.item.title}
      </Typography>

      {textElement}
    </Flex.Row>
  );
};
